import { render } from "./AuthSite.vue?vue&type=template&id=90717cfc"
import script from "./AuthSite.vue?vue&type=script&lang=js"
export * from "./AuthSite.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__